import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('educabot-pushbutton')
export class ButtonElement extends LitElement {
  static get properties() {
    return {
      id: {String},
      pressed: {String},
      rotation: {String},
      sliderOpen: {String},
    };
  }

  constructor() {
    super();
    this.pressed = false;
    this.sliderOpen = true;
  }

  handleRotation = (e) => {
    const newRotation = ((this.rotation - 90) < -270) ? 0 : this.rotation - 90;
    this.rotation = newRotation;
    const rotationEvent = new CustomEvent('component-rotation', { detail: { rotation: newRotation, component: this.id } });
    document.dispatchEvent(rotationEvent);
  }
  
  openSlider = (e) => {
    // this.sliderOpen = !this.sliderOpen;
    setTimeout(() => {
      if (!document.querySelector(`#${this.id}`).closest(".react-draggable").classList.contains("react-draggable-dragging")) {
        this.sliderOpen = !this.sliderOpen;
      }
    }, 100);
  }

  down = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!this.pressed) {
      this.pressed = true;
      this.dispatchEvent(new Event('button-press'));
    } else {
      return;
    }
  }

  up = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.pressed) {
      this.pressed = false;
      this.dispatchEvent(new Event('button-release'));
    } else {
      return;
    }
  }

  static get styles() {
    return css`
      .cls-1, .cls-2 { stroke: #000; stroke-width: .25px; }
      .cls-1, .cls-2, .cls-3, .cls-4 { stroke-linecap: round; stroke-linejoin: round; }
      .cls-2 { fill: none; }
      .cls-5 { fill: #4b84e9; stroke: #585858; stroke-miterlimit: 10; }
      .cls-5, .cls-3, .cls-4 { stroke-width: 3px; }
      .cls-4 { fill: #fff; stroke: #cacaca; }
      .cls-6 { fill: #484a93; }
      .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 { stroke-width: 0px; }
      .cls-7 { fill: #585858; }
      .cls-8 { fill: #222221; }
      .cls-9 { fill: #cacaca; }
      .cls-10 { fill: #da0000; }
      .cls-11 { fill: #ffff3c; }
      .cls-12 { fill: #e4e4e4; }
      .link { cursor: pointer; }

      .button .rotation {
          background-color: #212C4C;
          position: absolute;
          padding: 5px;
          border-radius: 50%;
          top: 5px;
          left: 0px;
          opacity: 0;
          height: 1px;
          width: 1px;
          transition: all 0.3s ease-in-out;
          pointer-events: none;
          font-size: 1.5em;
          cursor: pointer;
      }
      .button .rotation.open {
        pointer-events: auto;
        width: 16px;
        height: 16px;
        left: -40px;
        top: 0px;
        opacity: 1;
        box-shadow: 3px 3px 8px 2px rgba(0, 0, 0, 0.4);
      }
      .button .rotation.rotate_90 {
        left: -25px;
      }
    `;
  }

  render = () => {
    const buttonFill = this.pressed ? '#234a83' : '#4070b7';
    const buttonStroke = this.pressed ? '#13142b' : '#363636';

    return html`
      <div class="button" id="${this.id}">
      <div class="rotation${this.sliderOpen ? ' open' : ''}${(parseInt(this.rotation, 10) === -90 || parseInt(this.rotation, 10) === -270) ? ' rotate_90' : ''}" @click=${this.handleRotation}>
        <svg style="margin: 0;" focusable="false" viewBox="0 0 24 24" color="white" aria-hidden="true">
          <path fill="#fff" d="M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"></path>
        </svg>
      </div>
      <svg
        id="svg-${this.id}"
        data-name="Capa 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 142.33 56.97"
        width="15mm"
        height="9mm"
        transform="translate(0 0) rotate(${this.rotation})"
      >
        <g @mousedown=${this.openSlider} id="button" data-name="Capa 1">
          <g>
            <g id="SPLINE">
              <path class="cls-1" d="m63.12,56.83h74.84c.11,0,.22,0,.34,0s.22-.02.33-.04.22-.04.33-.06.21-.06.32-.09.21-.07.32-.12c.26-.11.5-.24.73-.39s.45-.33.64-.53.37-.41.53-.64.29-.48.39-.74c.07-.17.13-.35.18-.53s.09-.36.11-.54.03-.37.04-.56V4.38c0-.11,0-.22-.01-.34s-.02-.22-.04-.33-.04-.22-.06-.33-.06-.21-.09-.32-.07-.21-.12-.32c-.11-.26-.24-.5-.39-.73s-.33-.45-.53-.64-.41-.37-.64-.53-.48-.29-.74-.39c-.17-.07-.35-.13-.53-.18s-.36-.09-.54-.11-.37-.03-.56-.04H63.12c-.06,0-.12,0-.18.01s-.12.02-.18.04-.12.04-.18.06c-.09.04-.17.08-.24.13s-.15.11-.21.18-.12.14-.18.21-.1.16-.13.25-.06.17-.08.26-.02.18-.03.28v2.81c0,.12,0,.24-.02.36s-.02.24-.04.35-.04.23-.07.35-.06.23-.1.34-.08.23-.12.34c-.11.27-.25.54-.42.78s-.35.48-.56.69-.44.4-.69.56-.51.31-.78.42-.56.2-.85.26-.59.09-.89.09-.59-.03-.88-.09-.58-.15-.85-.26-.54-.25-.78-.42-.48-.36-.69-.57-.4-.44-.56-.69-.31-.51-.42-.79c-.08-.18-.14-.37-.19-.56s-.09-.38-.11-.58-.03-.4-.04-.59V1.58c0-.06-.01-.13-.02-.19s-.02-.12-.04-.18-.04-.12-.06-.18c-.04-.09-.08-.17-.13-.25s-.11-.15-.18-.22-.14-.13-.22-.18-.16-.1-.25-.13-.18-.07-.27-.08-.19-.02-.28-.03H4.73c-.11,0-.22.01-.34.02s-.22.02-.33.04-.22.04-.33.07-.21.06-.32.09-.21.07-.32.12c-.26.11-.5.24-.73.39s-.45.33-.64.53-.37.41-.53.64-.29.48-.39.74c-.07.17-.13.35-.18.53s-.09.36-.11.54-.03.37-.04.56v48.2c0,.11,0,.22.01.34s.02.22.04.33.04.22.06.33.06.21.09.32.07.21.12.32c.11.26.24.5.39.73s.33.45.53.64.41.37.64.53.48.29.74.39c.17.07.35.13.53.18s.36.09.54.11.37.03.56.04h46.45c.06,0,.13,0,.19-.01s.12-.02.18-.04.12-.04.18-.06c.09-.04.17-.08.25-.13s.15-.11.22-.18.13-.14.18-.22.1-.16.13-.25.07-.18.08-.27.02-.19.03-.28v-2.78c0-.12,0-.24.02-.36s.02-.24.04-.35.04-.23.07-.35.06-.23.1-.34.08-.23.12-.34c.11-.27.25-.54.42-.78s.36-.48.57-.69.44-.4.69-.56.51-.31.79-.42.56-.2.85-.26.59-.09.89-.09.59.03.88.09.58.15.85.26.54.25.78.42.48.36.69.57.4.44.56.69.31.51.42.79c.08.18.14.37.19.56s.09.38.12.58.03.4.04.59v2.81c0,.06,0,.12,0,.19s.02.12.04.18.04.12.06.18c.04.09.08.17.13.24s.11.15.18.22.14.12.21.18.16.1.25.13.17.06.27.08.18.02.28.03Z" />
            </g>
            <g id="SPLINE-2" data-name="SPLINE">
              <path class="cls-2" d="m115.94,28.9c0-2.14-.42-4.27-1.24-6.24s-2.03-3.78-3.54-5.29-3.32-2.72-5.29-3.54-4.11-1.24-6.24-1.24" />
            </g>
            <g id="SPLINE-3" data-name="SPLINE">
              <path class="cls-2" d="m83.31,28.9c0-2.14.42-4.27,1.24-6.24s2.03-3.78,3.54-5.29c1.51-1.51,3.32-2.72,5.29-3.54s4.11-1.24,6.24-1.24" />
            </g>
            <g id="LINE">
              <line class="cls-2" x1="83.31" y1="28.9" x2="83.31" y2="28.9" />
            </g>
            {/* ====== BUTTON ========= */}
            <g
              @mousedown=${this.down}
              @mouseup=${this.up}
              @touchstart=${this.down}
              @touchend=${this.up}
              @pointerleave=${this.up}
              id="SPLINE-4"
              data-name="SPLINE"
            >
              <path class="cls-3 link" fill="${buttonFill}" stroke="${buttonStroke}" d="m99.63,45.22c2.14,0,4.27-.42,6.24-1.24,1.97-.82,3.78-2.03,5.29-3.54s2.72-3.32,3.54-5.29,1.24-4.11,1.24-6.24-.42-4.27-1.24-6.24-2.03-3.78-3.54-5.29-3.32-2.72-5.29-3.54-4.11-1.24-6.24-1.24c-2.14,0-4.27.42-6.24,1.24-1.97.82-3.78,2.03-5.29,3.54-1.51,1.51-2.72,3.32-3.54,5.29s-1.24,4.11-1.24,6.24c0,2.14.42,4.27,1.24,6.24s2.03,3.78,3.54,5.29,3.32,2.72,5.29,3.54c1.97.82,4.11,1.24,6.24,1.24Z" />
            </g>
            <g id="LINE-2" data-name="LINE">
              <line class="cls-2" x1="115.94" y1="28.9" x2="115.94" y2="28.9" />
            </g>
            <g id="LINE-3" data-name="LINE">
              <rect class="cls-5" x="1.5" y="11.2" width="42.52" height="34.58" />
            </g>
            <g id="SPLINE-5" data-name="SPLINE">
              <path class="cls-4" d="m57.38,22.81c-.25,0-.5.02-.74.05s-.49.08-.72.14-.47.14-.7.24c-.34.14-.67.32-.98.52s-.6.44-.86.71-.5.55-.71.86-.38.64-.52.98-.25.7-.32,1.06-.11.73-.11,1.11.04.74.11,1.11.18.72.32,1.06.32.67.52.98.44.6.71.86.55.5.86.71.64.38.98.52c.14.06.28.11.42.16s.28.09.43.12.29.06.43.09.29.04.44.05.3.01.45.02c.25,0,.5-.02.74-.05s.49-.08.72-.14.47-.14.7-.24c.34-.14.67-.32.98-.52s.6-.44.86-.71.5-.55.71-.86.38-.64.52-.98.25-.7.32-1.06.11-.73.11-1.11-.04-.74-.11-1.11-.18-.72-.32-1.06-.32-.67-.52-.98-.44-.6-.71-.86-.55-.5-.86-.71-.64-.38-.98-.52c-.14-.06-.28-.11-.42-.16s-.28-.09-.43-.12-.29-.06-.43-.09-.29-.04-.44-.05-.3-.01-.45-.02Z" />
            </g>
            <g>
              <rect class="cls-9" x="73.98" y="32.2" width="4.54" height="2.27" transform="translate(42.91 109.58) rotate(-90)" />
              <rect class="cls-7" x="74.83" y="32.2" width="2.83" height="2.27" transform="translate(42.91 109.58) rotate(-90)" />
            </g>
            <g>
              <g id="LINE-4" data-name="LINE">
                <path class="cls-12" d="m31.64,4.23h-1.13s-2.27,0-2.27,0h-1.13v.57c.31,0,.57.25.57.57s-.25.57-.57.57v.57h1.13s2.27,0,2.27,0h1.13v-.57c-.07,0-.15-.02-.22-.04s-.13-.07-.18-.12-.1-.12-.12-.18-.03-.14-.04-.22c0-.07.02-.15.04-.22s.07-.13.12-.18.12-.1.18-.12.14-.03.22-.04" />
              </g>
              <rect class="cls-11" x="28.24" y="4.03" width="2.27" height="2.67" transform="translate(24 34.74) rotate(-90)" />
            </g>
            <g>
              <g id="LINE-5" data-name="LINE">
                <path class="cls-12" d="m68.37,26.43v1.13s0,2.27,0,2.27v1.13h.57c0-.31.25-.57.57-.57s.57.25.57.57h.57v-1.13s0-2.27,0-2.27v-1.13h-.57c0,.07-.02.15-.04.22s-.07.13-.12.18-.12.1-.18.12-.14.03-.22.04c-.07,0-.15-.02-.22-.04s-.13-.07-.18-.12-.1-.12-.12-.18-.03-.14-.04-.22" />
              </g>
              <rect class="cls-10" x="68.37" y="27.36" width="2.27" height="2.67" transform="translate(139 57.4) rotate(180)" />
            </g>
            <g>
              <rect class="cls-9" x="73.98" y="22.67" width="4.54" height="2.27" transform="translate(52.44 100.05) rotate(-90)" />
              <rect class="cls-7" x="74.83" y="22.67" width="2.83" height="2.27" transform="translate(52.44 100.05) rotate(-90)" />
            </g>
            <polygon class="cls-6" points="51.79 38.19 62.97 38.19 67.21 42.05 67.21 56.95 60.72 56.95 60.72 52.07 60.72 51.76 60.59 51.15 60.33 50.57 59.95 50.05 59.7 49.83 59.48 49.62 58.94 49.3 58.35 49.07 57.71 48.96 57.39 48.96 57.34 48.96 57.01 48.96 56.35 49.08 55.74 49.31 55.18 49.65 54.95 49.87 54.71 50.08 54.35 50.58 54.1 51.13 53.97 51.72 53.97 52.02 53.97 56.95 47.54 56.95 47.54 42.05 51.79 38.19" />
            <polygon class="cls-6" points="54.03 0 54.03 4.88 54.03 5.2 54.17 5.81 54.43 6.38 54.81 6.9 55.05 7.12 55.28 7.33 55.82 7.65 56.41 7.88 57.04 7.99 57.37 7.99 57.42 7.99 57.75 7.99 58.41 7.87 59.02 7.64 59.58 7.3 59.81 7.08 60.05 6.87 60.41 6.38 60.66 5.82 60.79 5.24 60.79 4.94 60.79 0 67.22 0 67.22 14.9 62.97 18.75 51.79 18.75 47.54 14.9 47.54 0 54.03 0" />
            <g>
              <path class="cls-6" d="m126.6,9.03h-.44l-.54-.54c-1.28-1.29-1.95-1.87-2.74-1.88-.53,0-1.03.25-1.03,1,0,.46.24.84.44,1.07l-.5.22c-.31-.35-.53-.85-.53-1.43,0-1.08.78-1.54,1.53-1.54.97,0,1.75.67,2.82,1.74l.39.4h.02v-2.26h.59v3.22Z" />
              <path class="cls-6" d="m121.85,2.18c0,.14,0,.32.03.51.19,1.07,1,1.64,1.86,1.75v-.02c-.33-.24-.61-.66-.61-1.22,0-.89.67-1.52,1.7-1.52.96,0,1.85.63,1.85,1.67s-.87,1.78-2.24,1.78c-1.03,0-1.85-.36-2.36-.85-.43-.42-.69-.98-.78-1.61-.03-.2-.04-.37-.04-.5h.58Zm3.03.19c-.75,0-1.2.41-1.2,1.04,0,.41.27.79.65.98.08.05.19.08.31.08.86-.02,1.5-.4,1.5-1.11,0-.59-.51-.98-1.26-.98Z" />
            </g>
            <g>
              <rect class="cls-6" x="32.34" y="50.06" width=".85" height=".85" />
              <rect class="cls-6" x="32.34" y="54.29" width=".85" height=".85" />
              <polygon class="cls-6" points="28.95 50.06 28.1 50.06 27.25 50.06 27.25 50.9 26.4 50.9 26.4 51.75 25.55 51.75 24.71 51.75 24.71 53.44 25.55 53.44 26.4 53.44 26.4 54.29 27.25 54.29 27.25 55.13 28.1 55.13 28.95 55.13 28.95 55.98 29.79 55.98 32.34 55.98 32.34 55.13 29.79 55.13 29.79 50.06 32.34 50.06 32.34 49.21 29.79 49.21 28.95 49.21 28.95 50.06" />
              <rect class="cls-6" x="33.18" y="50.9" width=".85" height="3.38" />
            </g>
            <path class="cls-6" d="m107.34,21.98h56.96v8.78c0,2.34-1.9,4.24-4.24,4.24h-48.48c-2.34,0-4.24-1.9-4.24-4.24v-8.77h0Z" transform="translate(107.34 164.31) rotate(-90)" />
            <g>
              <path class="cls-8" d="m133.36,37.45c-.05-.24-.09-.61-.09-.99,0-.54.1-.89.32-1.15.17-.22.43-.35.77-.35.42,0,.79.27.96.71h.01c.1-.4.45-.87,1.1-.87.38,0,.66.14.88.36.28.29.41.77.41,1.45,0,.37-.03.66-.05.84h-4.31Zm1.79-.54v-.49c0-.57-.31-.91-.73-.91-.51,0-.72.37-.72.92,0,.25.02.39.04.48h1.41Zm2.1,0c.02-.11.03-.26.03-.46,0-.56-.21-1.08-.85-1.08-.6,0-.84.49-.84,1.09v.45h1.67Z" />
              <path class="cls-8" d="m135.44,30.47c1.51,0,2.31.88,2.31,1.95s-.9,1.89-2.22,1.89c-1.39,0-2.3-.83-2.3-1.95s.92-1.89,2.22-1.89Zm.07,3.26c.94,0,1.78-.49,1.78-1.34s-.83-1.35-1.82-1.35c-.87,0-1.78.44-1.78,1.34s.86,1.35,1.83,1.35Z" />
              <path class="cls-8" d="m133.78,29.12v1.28h-.48v-3.11h.48v1.29h3.9v.55h-3.9Z" />
              <path class="cls-8" d="m135.44,23.39c1.51,0,2.31.88,2.31,1.95s-.9,1.89-2.22,1.89c-1.39,0-2.3-.83-2.3-1.95s.92-1.89,2.22-1.89Zm.07,3.26c.94,0,1.78-.49,1.78-1.34s-.83-1.35-1.82-1.35c-.87,0-1.78.44-1.78,1.34s.86,1.35,1.83,1.35Zm-3.22-2.25l.75.79v.45l-.75-.58v-.66Z" />
              <path class="cls-8" d="m137.68,22.68h-4.38v-.59l2.22-1.35c.51-.31.98-.56,1.42-.75h0c-.59.04-1.12.05-1.8.05h-1.83v-.51h4.38v.55l-2.22,1.34c-.49.29-.99.57-1.46.79v.02c.56-.03,1.09-.04,1.81-.04h1.87v.51Z" />
            </g>
          </g>
        </g>
      </svg>
      </div>
    `;
  };
}
